import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-65',
  templateUrl: './cards10-examples-65.component.html'
})
export class Cards10Examples65Component {}
